export type IGetUrlParamValue = (param: string, url: string) => string | undefined;

export function getUrlParamValue(param: string, url: string): string | undefined {
  const parsedUrl = window.DexeroCoreApp.paraseURL(url);
  if (!Object.hasOwnProperty.call(parsedUrl, param)) {
    return;
  }
  return parsedUrl[param];
}
